<app-tenant-config-proxy [configPath]="'connectionChangeRequest.isActive'" [redirectOnDeactivated]="true">
  <ng-container *ngIf="model$ | async as model; else noData">
    <app-order-request-wizard
      *ngIf="token$ | async as token"
      [model]="model"
      [info]="info$ | async"
      [token]=""
      (onSubmitModel)="submitFeedback($event, token)" />
  </ng-container>
  <ng-template #noData>
    <app-error
      [errorMessage]="
        'Leider konnten wir Ihren Antrag nicht finden. Bitte überprüfen Sie Ihren Link und stellen sicher, dass das Zeitfenster für Ihre Rückmeldung noch nicht abgelaufen ist.'
      " />
  </ng-template>
</app-tenant-config-proxy>
